module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.e6f572c.ttf";